import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e6ed106"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = { class: "modal-card" }
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = { class: "modal-card-title is-title-shrink" }
const _hoisted_6 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoneyTransaction = _resolveComponent("MoneyTransaction")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$gettext("Top up my account")), 1),
        _createElementVNode("button", {
          class: "delete",
          "aria-label": "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetCredit(), _ctx.$modal.close()))
        })
      ]),
      _createElementVNode("section", {
        class: "modal-card-body",
        tabindex: "0",
        onKeyup: _cache[4] || (_cache[4] = _withKeys(
          () => {
            if (_ctx.amountError === false && _ctx.isValid) _ctx.newLinkTab()
          }
        , ["enter"]))
      }, [
        _createVNode(_component_MoneyTransaction, {
          directionTransfer: "receive",
          account: this.$modal.args.value[0].account,
          parentErrors: _ctx.amountError,
          transactionType: "topup",
          "onUpdate:amount": _cache[1] || (_cache[1] = (x) => (_ctx.amount = x)),
          "onUpdate:isValid": _cache[2] || (_cache[2] = (x) => (_ctx.isValid = x)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errors = false))
        }, null, 8, ["account", "parentErrors"])
      ], 32),
      _createElementVNode("footer", _hoisted_6, [
        (
            _ctx.creditOrderUrl.length === 0 &&
            (_ctx.selectedCreditAccount || _ctx.creditableMoneyAccounts.length === 1)
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button custom-button-modal button-modal has-text-weight-medium action",
              id: "top-up-button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.newLinkTab())),
              disabled: _ctx.amountError !== false || !_ctx.isValid
            }, _toDisplayString(_ctx.$gettext("Next")), 9, _hoisted_7))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}